import React from 'react';
import { Modal, Form, Input, message } from 'antd';
import { useTranslation } from '@refinedev/core';
import { endPoints } from '@/api/configs';
import useAPI from '@/api/useApi';

interface AddContactUsEmailModalProps {
  open: boolean;
  onCancel: () => void;
  refetch: () => void;
}

export const AddContactUsEmailModal: React.FC<AddContactUsEmailModalProps> = ({
  open,
  onCancel,
  refetch,
}) => {
  const { translate } = useTranslation();
  const [form] = Form.useForm();
  const { usePatch } = useAPI();
  const { mutate: createEmail, isLoading } = usePatch(endPoints.systemConfig);
  const handleOk = async () => {
    const values = await form.validateFields();
    if (values) {
      createEmail(
        {
          operation: 'ADD',
          field: 'ADMIN_EMAIL',
          value: form.getFieldValue('email'),
        },
        {
          onSuccess: () => {
            message.success(translate('system-config.contact-us.added'));
            form.resetFields();
            onCancel();
            refetch();
          },
          onError: (error) => {
            message.error(error.message);
          },
        }
      );
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title={translate('system-config.contact-us.addEmail')}
      open={open}
      onOk={handleOk}
      okText={translate('system-config.contact-us.addEmail')}
      onCancel={handleCancel}
      cancelText={translate('system-config.contact-us.cancel')}
      okButtonProps={{ loading: isLoading }}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="email"
          label={translate('system-config.contact-us.email')}
          rules={[
            {
              required: true,
              message: translate('pages.errors.required'),
            },
            {
              type: 'email',
              message: translate('pages.errors.invalidEmail'),
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};
